import { Label } from "../ui/label";
import { AREAS } from "../../constants";

export default function UserAreaPicker({ selected = [], onToggle }) {
  return (
    <div>
      <Label className="text-[10.5px] tracking-eyebrow uppercase text-[#0B1F3A]/60">Assigned areas</Label>
      <div className="mt-2 flex flex-wrap gap-2">
        {AREAS.map((a) => {
          const active = selected.includes(a.id);
          return (
            <button
              key={a.id}
              type="button"
              onClick={() => onToggle(a.id)}
              className={`h-9 px-4 rounded-full text-sm border transition-colors ${
                active
                  ? "bg-[#0B1F3A] text-white border-[#0B1F3A]"
                  : "bg-white text-[#0B1F3A] border-[#E6E0D4] hover:border-[#0B1F3A]/40"
              }`}
            >
              {a.name}
            </button>
          );
        })}
      </div>
      <p className="text-xs text-[#0B1F3A]/55 mt-1.5">
        Pick one or more. Products must match at least one of these to appear on this user's iPad.
      </p>
    </div>
  );
}
